import React, { useEffect } from 'react';
import useDropdownField from '@/hooks/useDropdownField.js';

function SearchableDropdown({
  items = [],
  searchKey = 'name',
  displayKey = 'name',
  placeholder = 'Search...',
  label,
  onSelect,
  className = '',
  required = false,
  renderItem,
  getDisplayValue
}) {
  const {
    searchTerm,
    isOpen,
    filteredItems,
    handleSelect,
    handleInputChange,
    handleInputFocus,
    handleInputClick,
    dropdownId
  } = useDropdownField(items, searchKey, displayKey, getDisplayValue);
  


  const handleItemSelect = (item) => {
    handleSelect(item);
    onSelect?.(item);
  };

  return (
    <div className={`mb-6 ${className}`}>
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-2">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      
      <div 
        className="relative" 
        onClick={(e) => e.stopPropagation()}
        data-dropdown-id={dropdownId}
      >
        <input
          type="text"
          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition-colors"
          placeholder={placeholder}
          value={searchTerm}
          onChange={(e) => handleInputChange(e.target.value)}
          onFocus={handleInputFocus}
          onClick={handleInputClick}
          required={required}
        />
        
        {isOpen && (
          <div className="absolute top-full left-0 right-0 bg-white border border-gray-300 rounded-lg max-h-48 overflow-y-auto z-50 shadow-lg">
            {filteredItems.length > 0 ? (
              filteredItems.map((item, index) => (
                <div
                  key={item.id || index}
                  className="px-4 py-3 cursor-pointer border-b border-gray-100 hover:bg-gray-50 transition-colors"
                  onMouseDown={() => handleItemSelect(item)}
                >
                  {renderItem ? renderItem(item) : (
                    <>
                      <div className="font-medium text-gray-900">
                        {item[searchKey]}
                      </div>
                      {displayKey !== searchKey && (
                        <div className="text-sm text-gray-600">
                          {item[displayKey]}
                        </div>
                      )}
                    </>
                  )}
                </div>
              ))
            ) : searchTerm.trim() ? (
              <div className="px-4 py-3 text-gray-500 text-sm">
                No items found
              </div>
            ) : null}
          </div>
        )}
      </div>
    </div>
  );
}

export default SearchableDropdown; 